import React from 'react';
import {
  FluentProvider,
  teamsLightTheme,
  Button,
} from '@fluentui/react-components';
import { CheckmarkCircle24Regular } from '@fluentui/react-icons';
import { useNavigate } from "react-router-dom";

const SuccessScreen = () => {
  const navigate = useNavigate();
  return (
    <FluentProvider theme={teamsLightTheme}>
      <div style={{ padding: 20, maxWidth: 400, minHeight: '90vh' }}>
        <div>
          <Button appearance="subtle" icon={<span style={{display:'inline-block',transform:'rotate(180deg)'}}>&#8594;</span>} onClick={() => navigate(-1)} aria-label="Back" />
        </div>
        <div style={{ marginTop: 16 }}>
          <div style={{ fontWeight: 'bold', fontSize: '0.875rem' }}>
            Health Partners Transcript Assistant
          </div>
          <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>
            ACAB/MR/25/9044
          </div>
          <div style={{ fontWeight: 600, marginTop: 4 }}>QF 801</div>
        </div>

        <div
          style={{
            backgroundColor: '#EFFFF4',
            color: '#0F703E',
            borderRadius: 6,
            padding: '12px',
            display: 'flex',
            alignItems: 'start',
            gap: 8,
            marginTop: 24,
            fontSize: '0.875rem',
            border: '1px solid #A4D7B5',
          }}
        >
          <CheckmarkCircle24Regular />
          <div>
            <strong>Notes Successfully Generated</strong><br />
            The QF-802 has been successfully<br />
            created on 24/04/2025 15:24
          </div>
        </div>

        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <Button appearance="primary">View Document</Button>
        </div>
      </div>
    </FluentProvider>
  );
};

export default SuccessScreen;
